import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { CourseForm } from '../../../../components/admin/CourseForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/courses/new',
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role;
    if (role !== 'super_admin') throw redirect({ to: '/app' });
  },
  component: NewCoursePage,
});

function NewCoursePage() {
  return (
    <div>
      <AdminPageHeader
        title="New course"
        description="Add a master course. Once curated, it appears in tenants' catalogues per your sharing rules."
        backTo="/app/admin/courses"
        backLabel="All courses"
      />
      <CourseForm />
    </div>
  );
}
